<template>
	<div class="container">
		<div class="top-wrapper">
			<div class="nav-item" id="left-nav-item" @click="goSetting">
				<img class="nav-icon" src="../../assets/image/change-icon/f0_setup@2x.png" />
			</div>
			<div class="nav-item" id="right-nav-item" @click="goNews()">
				<img class="nav-icon" src="../../assets/image/change-icon/f0_message@2x.png" />
				<!-- <span v-if="isHasUnreadCount">{{systemUnreadCount}}</span> -->
				<span v-if="isHasUnreadCount"></span>
			</div>
			<div class="top-info-wrapper">
				<div class="avatar-wrapper" @click="goProfileInfo">
					<img class="avatar" v-bind:src="user.avatar.thumb" v-if="isOnline && user && user.avatar"/>
					<img class="avatar" src="../../assets/image/change-icon/e0_head1@2x.png" v-if="!isOnline || !user || !user.avatar"/>
				</div>
				<label class="nickname" style="-webkit-box-orient:vertical" @click="goProfileInfo">{{nickname}}</label>
			</div>
			<div class="info-wrapper">
				<div class="info-item" @click="goScoreList">{{getScore}}积分</div>
				<div class="info-item" @click="goRecordList">积分记录</div>
			</div>
		</div>
		<div class="order-header">
			<div class="order-header-item" id="order-item-left">
				<img class="order-header-icon" src="../../assets/image/change-icon/e1_order@2x.png" />
				<label class="item-title order-header-title">我的订单</label>
			</div>
			<div class="order-header-item" id="order-item-right">
				<label class="order-subtitle">查看全部订单</label>
				<img class="indicator" src="../../assets/image/change-icon/enter@2x.png" />
			</div>
			<div class="order-header-line"></div>
		</div>
		<!-- <div class="order-wrapper" >
			<profile-order-type-item
			    :id='1'
				class="order-item"
				:icon="require('../../assets/image/change-icon/f0_icon_pay@2x.png')"
				title="到家订单">
			</profile-order-type-item>
			<profile-order-type-item
			    :id="0"
			   	@goOrder="goOrder"
				class="order-item"
				:icon="require('../../assets/image/change-icon/f0_delivery@2x.png')"
				title="门店订单">
			</profile-order-type-item>
		</div> -->
		<div class="order-wrapper" >
			<profile-order-item
				class="order-item"
				testAttr = 'order'
				id='0'
				:icon="require('../../assets/image/change-icon/f0_icon_pay@2x.png')"
				title="待付款"
				:orderNumber = 'orderCount.created'>
			</profile-order-item>
			<profile-order-item
				class="order-item"
				testAttr = 'order'
				id='1'
				:icon="require('../../assets/image/change-icon/f0_delivery@2x.png')"
				title="待发货"
				:orderNumber = 'orderCount.paid'>
			</profile-order-item>
			<profile-order-item
				class="order-item"
				testAttr = 'order'
				id='2'
				:icon="require('../../assets/image/change-icon/f0_receiving@2x.png')"
				title="待收货"
				:orderNumber = 'orderCount.delivering'>
			</profile-order-item>
			<profile-order-item
				class="order-item"
				testAttr = 'order'
				id='3'
				:icon="require('../../assets/image/change-icon/f0_evaluate@2x.png')"
				title="待评价"
				:orderNumber = 'orderCount.deliveried'>
			</profile-order-item>
		</div>
		<div class="bottom-wrapper">
			<profile-info-item
				v-on:onclick="goFavourite()"
				class="info-item-wrapper section-header"
				:icon="require('../../assets/image/change-icon/f0_favorite@2x.png')"
				title="我的收藏">
			</profile-info-item>
			<profile-info-item
				v-on:onclick="goAddress"
				class="info-item-wrapper"
				:icon="require('../../assets/image/change-icon/f0_address@2x.png')"
				title="管理收货地址">
			</profile-info-item>
			<profile-info-item
				v-on:onclick="goCashgift"
				class="info-item-wrapper section-footer"
				:icon="require('../../assets/image/change-icon/f0_coupon@2x.png')"
				title="我的红包">
			</profile-info-item>
			<profile-info-item
				v-on:onclick="goBonus"
				class="info-item-wrapper section-header"
				:icon="require('../../assets/image/change-icon/f0_recommend@2x.png')"
				title="我的推荐">
			</profile-info-item>
			<profile-info-item
				v-on:onclick="goBalance"
				class="info-item-wrapper section-header"
				:icon="require('../../assets/image/change-icon/f0_balance@2x.png')"
				title="我的资金">
			</profile-info-item>
			<profile-info-item
				v-on:onclick="goHelp()"
				class="info-item-wrapper section-footer"
				:icon="require('../../assets/image/change-icon/f0_help@2x.png')"
				title="使用帮助">
			</profile-info-item>
			<!-- <profile-info-item
				v-on:onclick="goBonusQR"
				class="info-item-wrapper section-header"
				:icon="require('../../assets/image/change-icon/f0_qcode@2x.png')"
				title="我的推广二维码">
			</profile-info-item> -->
			<profile-info-item
			 	v-if="isAPP"
				v-on:onclick="share"
				class="info-item-wrapper section-header"
				:icon="require('../../assets/image/change-icon/f0_recommend@2x.png')"
				title="分享有奖">
			</profile-info-item>
		</div>
		<div class="dialog-wrapper" v-if="isDialog">
			<div class="top">
				<img class="box_item" src="../../assets/image/profile/xiao@2x.png" />
			</div>
			<div class="box">
				<img @click="shareContent('0')" class="box_item" src="../../assets/image/profile/weixin@2x.png" />
				<img @click="shareContent('1')" class="box_item" src="../../assets/image/profile/pengyouquan@2x.png" />
				<img @click="shareContent('2')" class="box_item" src="../../assets/image/profile/QQ@2x.png" />
				<img @click="shareContent('3')" class="box_item" src="../../assets/image/profile/QQkongjian@2x.png" />
				<div>选择分享方式</div>
			</div>
			<div class="footer">
				<img  @click="()=>{this.isDialog =false}" class="box_item" src="../../assets/image/profile/close@2x.png" />
			</div>
		</div>
		<div class="cashgift-wrapper" ref="registered" v-if="isRegistered">
			<div class="box">
				<cashgift-list></cashgift-list>
			</div>
			<div class="footer" @click="$router.push({ name: 'cashgiftList', query: { index: 0 } })">
				<div>立即领取新人大礼包</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Tabbar from '../../components/common/Tabbar';
	import ProfileInfoItem from './child/ProfileInfoItem';
	import ProfileOrderItem from './child/ProfileOrderItem';
	import ProfileOrderTypeItem from './child/ProfileOrderTypeItem';
	import { mapState, mapGetters, mapMutations } from 'vuex';
	import { userProfileGet } from '../../api/user';
	import { scoreGet } from '../../api/score';
	import { ENUM } from '../../const/enum';
	import { orderSubtotal } from '../../api/order';
	import { messageCount } from '../../api/message';
	import * as site from '../../api/site';
	import { MessageBox , Toast } from 'mint-ui';
	import CashgiftList from './child/CashgiftList'
	import { cashgiftList,registerCashgiftList } from '../../api/cashgift'
	export default {
		name: 'profile',
		data() {
			return {
				isDialog:false,
				isRegistered:false,
				orderAll: 1,
				score: 0,
				orderCount: {},
				isShow: true,				
				telephone: ''
			};
		},
		components: {
			Tabbar,
			ProfileOrderItem,
			ProfileInfoItem,
			ProfileOrderTypeItem,
			'cashgift-list':CashgiftList
		},
		created: function() {
			if(this.$route.params && this.$route.params.from){
				registerCashgiftList('', '', 0).then(res => {         
				if (res && res.cashgifts  &&  res.cashgifts.length>0) {          
					this.isRegistered = true 
					}
				}, error => {         
				})
			}
			if (this.isOnline) {
				userProfileGet().then( response => {
					if (response && response.user) {
						this.saveUser(response);
					}
				},error => {}
				);
				scoreGet().then( response => {
						this.score = response.score;
					},
					error => {}
				);
			}
			if (this.isOnline) {
				this.getOrderSubtotal();
				this.getMessageCount(ENUM.MESSAGE_TYPE.SYSTEM);
				// this.getMessageCount(ENUM.MESSAGE_TYPE.ORDER);
			}
			site.siteGet().then( response => {
					if (response && response.site_info) {
						this.telephone = response.site_info.telephone;
					}
				},
				error => {}
			);
		},
		computed: {
			...mapState({
				isOnline: state => state.auth.isOnline,
				user: state => state.auth.user,
				lastOrderMsgTime: state => state.message.lastOrderMsgTime,
				lastSystemMsgTime: state => state.message.lastSystemMsgTime,
				orderUnreadCount: state => state.message.orderUnreadCount,
				systemUnreadCount: state => state.message.systemUnreadCount,
				orderStatus: state => state.order.orderStatus
			}),
			...mapGetters({
				isHasUnreadCount: 'isHasUnreadCount'
			}),
			hasRegistered(){
				console.dir(this.$refs.registered)
				return 1
			},
			isAPP(){
				return  window.android || window.webkit
			},
			nickname() {
				let title = '登录/注册';
				if (this.isOnline) {
					if ( this.user && typeof this.user != 'undefined' && JSON.stringify(this.user) != '{}' ) {
						if (this.user.nickname) {
							title = this.user.nickname;
						} else if (this.user.username) {
							title = this.user.username;
						}
					}
				}
				return title;
			},
			getAvatarUrl() {
				let url = null;
				if (this.isOnline) {
					if ( this.user && typeof this.user != 'undefined' && JSON.stringify(this.user) != '{}' ) {
						let avatar = this.user.avatar;
						if (avatar) {
							if (avatar.large && avatar.large) {
								url = avatar.large;
							} else if (avatar.thumb && avatar.thumb) {
								url = avatar.thumb;
							}
						}
					}
				}
				if (url === null) {
					url = require("../../assets/image/change-icon/e0_head1@2x.png");
				}
				return url;
			},
			getScore() {
				let score = '0';
				if (this.isOnline) {
					score = this.score;
				}
				return score;
			},
		},
		methods: {
			...mapMutations({
				saveUser: 'saveUser',
				changeStatus: 'changeStatus',
				saveOrderUnread: 'saveOrderUnread',
				saveSystemUnread: 'saveSystemUnread'
			}),
			// 获取订单不同状态的数量统计
			getOrderSubtotal() {
				if (this.user != null) {
					orderSubtotal().then(res => {
						if (res) {
							this.orderCount = res.subtotal;
						}
					});
				}
			},
			// 获取未读消息数字
			getMessageCount(type) {
				if (this.user != null) {
					let after = null
					if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
						after = this.lastSystemMsgTime ? this.lastSystemMsgTime : Date.parse( new Date()) / 1000
					}
					// } else if (type === ENUM.MESSAGE_TYPE.ORDER) {
					// 	after = this.lastOrderMsgTime ? this.lastOrderMsgTime : '0'
					// }
					
					messageCount(after, type).then(res => {
						if (res) {
							if (type === ENUM.MESSAGE_TYPE.SYSTEM) {
								this.saveSystemUnread(res.count);
							} else if (type === ENUM.MESSAGE_TYPE.ORDER) {
								this.saveOrderUnread(res.count);
							}
						}
					});
				}
			},
			showLogin() {
				this.$router.push({ name: 'signin' });
			},
			goScoreList() {
				if (this.isOnline) {
					this.$router.push({ name: 'scoreList', query: { index: 0 } });
				} else {
					this.showLogin();
				}
			},
			goRecordList() {
				if (this.isOnline) {
					this.$router.push({ name: 'scoreList', query: { index: 1 } });
				} else {
					this.showLogin();
				}
			},
			goProfileInfo() {
				if (this.isOnline) {
					this.$router.push({'name': 'profileInfo'});
				} else {
					this.showLogin();
				}
			},
			goSetting() {
				this.$router.push({ name: 'setting' });
			},
			goNews() {
				if (this.isOnline) {
					this.$router.push({ name: 'systemMessageList' });
				} else {
					this.showLogin();
				}
			},
			goFavourite() {
				if (this.isOnline) {
					this.$router.push('collection');
				} else {
					this.showLogin();
				}
			},
			goAddress() {
				if (this.isOnline) {
					this.$router.push({ name: 'addressManage' });
				} else {
					this.showLogin();
				}
			},
			goCashgift() {
				if (this.isOnline) {
					this.$router.push({ name: 'cashgiftList', query: { index: 0 } });
				} else {
					this.showLogin();
				}
			},
			goHelp() {
				this.$router.push('help');
			},
			goOrder() {
				if (this.isOnline) {
					if (this.orderStatus != 10) {
						this.changeStatus(10);
					}
					this.$router.push({
						name: 'order',
						params: { order: ENUM.ORDER_STATUS.ALL }
					});
				} else {
					this.showLogin();
				}
			},
			goBonus() {
				if (this.isOnline) {
					this.$router.push({ name: 'bonusList' });
				} else {
					this.showLogin();
				}
			},
			goBalance() {
				if (this.isOnline) {
					this.$router.push({ name: 'balanceUsable' });
				} else {
					this.showLogin();
				}
			},
			goBonusQR() {
				if (this.isOnline) {
					this.$router.push({ name: 'bonusQR' });
				} else {
					this.showLogin();
				}
			},
			share(){
				this.isDialog =true
			},
			shareContent(platform){
				// 参数都为string类型
				// platform 分享的平台 string类型 0 微信、1朋友圈、2 QQ、3QQ空间
				// title    分享的标题 string类型
				// subtitle 分享的副标题 string类型
				// icon     分享的图标链接 string类型
				// url      分享的内容链接 string类型
				let title = '华联超市APP分享'
				let subtitle = '油田独家手机端便利超市，赶快来看看吧~！'
				let icon = 'http://premall.bestegou.com/images/share_logo.png'
				let url = 'http://hlmall.bestegou.com/hl2208.html'
				
				if(window.android){
					 window.android.shareContent(platform,title,subtitle,icon,url)
				}else if(window.webkit){
					window.webkit.messageHandlers.shareContent.postMessage({platform,title,subtitle,icon,url});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color: $mainbgColor;
	.top-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		height: 225px;
		@include linear-gradient(#FA800A, #FA800A);
		.top-info-wrapper {
			flex: 1;
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
		}
	}
	.nav-item {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 44px;
		height: 44px;
		top: 11px;
		span {
			width: 7px;
			height: 7px;
			background-color: red;
			border-radius: 50%;
			position: absolute;
			top: 8px;
			font-size: 18px;
		}
	}
	#left-nav-item {
		left: 2px;
	}
	#right-nav-item {
		right: 2px;
	}
	.nav-icon {
		width: 24px;
		height: 24px;
	}
	.avatar-wrapper {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		width: 76px;
		height: 76px;
		border-radius: 38px;
		background-color: #fff;
		margin-top: 40px;
		.avatar {
			width: 72px;
			height: 72px;
			border-radius: 36px;
		}
	}
	.nickname {
		width: 100%;
		margin-top: 20px;
		font-size: 16px;
		font-family:PingFangSC-Regular;
		color:rgba(255,255,255,1);
		text-align: center;
		margin-left: 0px;
		margin-right: 0px;
		@include limit-line(1);
	}
	.info-wrapper {
		width: 100%;
		height: 40px;
		display: inline-flex;
		flex-direction: row;
		justify-content: flex-start;
		align-content: stretch;
		background-color: rgba(0, 0, 0, 0.1);
	}
	.info-item {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		color: #fff;
	}
	.order-header {
		height: 44px;
		position: relative;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-content: stretch;
		background-color: #fff;
		@include thin-border();
	}
	.order-header-item {
		flex: 1;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	#order-item-left {
		justify-content: flex-start;
		margin-left: 10px;
	}
	#order-item-right {
		justify-content: flex-end;
	}
	.order-header-line {
		position: absolute;
		height: 1px;
		left: 10px;
		bottom: 0px;
		right: 10px;
		background-color: $lineColor;
	}
	.item-title {
		font-size: 14px;
		color: #4e545d;
	}
	.order-header-icon {
		width: 18px;
		height: 18px;
	}
	.order-header-title {
		margin-left: 8px;
	}
	.indicator {
		width: 7px;
		height: 12 px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.order-subtitle {
		font-size: 12px;
		color: #7c7f88;
	}
	.order-wrapper {
		height: 88px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: stretch;
		background-color: #fff;
	}
	.order-item {
		flex: 1;
	}
	.bottom-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: stretch;
		margin-bottom: 60px;
	}
	.cashgift-wrapper{
		z-index: 2000;
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background-color:rgba(0, 0, 0, 0.5);
		padding-top:20vh;
		margin-bottom:20vh;
		.box{
			border-radius: 6vw;
			padding-top: 3vh;
			padding-bottom: 3vh;
			width: 80vw;
			background-color:rgb(255, 0, 0);
			text-align: center;
		}
		.footer{
			border-radius: 6vw;
			margin-top: 4vw;
			width: 40vw;
			height: 6vh;
			line-height: 6vh;
			color:rgb(233, 230, 40);
			font-size: 0.8rem;
			text-align: center;
			background-color:rgb(255, 0, 0);
		}
	}
	.dialog-wrapper{
		z-index: 2000;
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background-color:rgba(0, 0, 0, 0.5);
		padding-top:20vh;
		.top{
			margin-bottom: -10vw;
			img{
				width: 20vw;
				height: 20vw;
			}
			z-index: 3000;
		}
		.box{
			border-radius: 6vw;
			padding-top:14vh;
			padding-bottom: 2vh;
			width: 80vw;
			height: 16vh;
			background-color:#ffffff;
			text-align: center;
			img{
				width: 12vw;
				height: 12vw;
				padding-left:2vw;
				padding-right: 2vw; 
			}
			div{
				color:#4E545D;
				margin-top: 6vw;
				font-size: 4vw;
			}
		}
		.footer{
			margin-top: 4vw;
			img{
				width: 12vw;
				height: 12vw;
			}
		}
	}
	.info-item-wrapper {
		height: 44px;
	}
	.section-header {
		margin-top: 12px;
	}
	.section-footer {
		border-bottom-width: 0px;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/profile/Profile.vue